import { sendToMap } from "pages/graphicset/utils";
import uniqueId from "lodash/uniqueId";

export const MAX_POS_X = 1920;
export const MAX_POS_Y = 1080;

// size is obtained from selected asset
export default (schedules, layouts) => ({
  id: uniqueId(),
  order: layouts.length,
  assetId: "",
  assetIdCodename: "",
  assetIdCategoryIds: null,
  asset: {
    codename: "",
    image: "",
    description: "",
    categoryIds: null,
  },
  sendTo: sendToMap.gallery,
  pos: {
    x: 0,
    y: 0,
  },
  size: {
    x: 0,
    y: 0,
  },
  segments: schedules.map(schedule => ({
    id: uniqueId(),
    type: schedule.type,
    start: 0,
    end: 20,
  })),
  originalSize: {
    x: 0,
    y: 0,
  },
  seconds: 0,
});
